import { TabletsApiFactory, V1Tablet, V1TabletStatus } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { Tablet, TabletDetails, TabletStatus } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'

function convertTabletStatus(rawTabletStatus?: V1TabletStatus): TabletStatus {
  switch (rawTabletStatus) {
    case V1TabletStatus.UNKNOWNTABLETSTATUS:
      return TabletStatus.UNKNOWNTABLETSTATUS
    case V1TabletStatus.UNINITIALIZED:
      return TabletStatus.UNINITIALIZED
    case V1TabletStatus.RUNNING:
      return TabletStatus.RUNNING
    case V1TabletStatus.SUSPENDED:
      return TabletStatus.SUSPENDED
    default:
      return TabletStatus.UNKNOWNTABLETSTATUS
  }
}

function createTablets(rawTablets?: V1Tablet[]): Tablet[] {
  if (!rawTablets) return [] as Tablet[]

  return rawTablets.map((t: V1Tablet): Tablet => {
    return new Tablet({
      id: t.id,
      mac: t.mac,
      companyId: t.companyId,
      details: new TabletDetails({
        latestDateTime: t.details?.latestDataTime,
        status: convertTabletStatus(t.details?.status)
      })
    })
  })
}

export const NewTabletsApiFunc = () => {
  const webAdapter = TabletsApiFactory(undefined, api.defaults.baseURL, api)

  return {
    adminUnassignTablet: async (companyId: string, tabletId: string): Promise<ApiResponse<void>> => {
      let data, err

      try {
        await webAdapter.adminDeleteTablet(companyId, tabletId)
      } catch (e) {
        err = e
      }

      return {
        data,
        err
      }
    },

    adminGetTablet: async (companyId: string, tabletId: string): Promise<ApiResponse<Tablet | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.adminGetTablet(companyId, tabletId)
        data = createTablets([res.data])[0]
      } catch (e) {
        err = e
      }

      return {
        data,
        err
      }
    },

    listTablets: async (
      companyId: string,
      filter?: string,
      page?: number
    ): Promise<ApiResponse<ListResponse<Tablet>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.listTablets(companyId, filter, page)
        data = createTablets(res.data.tablets)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as Tablet[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    }
  }
}